import { ErrorHandler, Injectable } from '@angular/core';
import { shouldReloadForChunkLoadError, safeReloadOnce } from './chunk-load-recover';

/**
 * Global Error Handler
 * 
 * Catches all unhandled errors in the Angular application and handles
 * chunk load errors by triggering a page reload to recover from stale
 * cached index.html references.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  /**
   * Handles errors that occur in the Angular application.
   * 
   * @param err - The error that occurred
   */
  handleError(err: unknown): void {
    // Log all errors for debugging
    console.error('[GlobalErrorHandler] Unhandled error:', err);

    // Check if this is a chunk load error
    if (shouldReloadForChunkLoadError(err)) {
      console.warn('[GlobalErrorHandler] Chunk load error detected. Attempting recovery...');
      safeReloadOnce();
      return;
    }

    // For other errors, just log them (existing error handling will take care of them)
    // You can add additional error handling logic here if needed
  }
}
